import { Button, Stack, Typography, useTheme } from "@mui/material";
import { ChevronDown, ChevronUp } from "lucide-react";
import { type FC, useState } from "react";
import { WhatToCountCategoryList } from "web_myplann/Finances/Components/WhatToCountCategoryList";
import {
	useWhatToCountContent,
	type WhatToCountKind,
} from "web_myplann/Finances/Hooks/useWhatToCountContent";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";

const COLLAPSED_CATEGORY_COUNT = 2;

type Props = {
	kind: WhatToCountKind;
};

export const WhatToCountSection: FC<Props> = ({ kind }) => {
	const theme = useTheme();
	const { t } = useResource();
	const { intro, categories } = useWhatToCountContent(kind);
	const [expanded, setExpanded] = useState(false);

	const visibleCategories = expanded
		? categories
		: categories.slice(0, COLLAPSED_CATEGORY_COUNT);
	const ToggleIcon = expanded ? ChevronUp : ChevronDown;

	return (
		<Stack mx={theme.spacingTokens.lg} mb={theme.spacingTokens.lg}>
			<Typography variant="bodyStrong" mb={theme.spacingTokens.xs}>
				{t(Resources.Finances.WhatToCount.title)}
			</Typography>
			<Stack
				bgcolor={theme.palette.blue[50]}
				borderRadius={theme.radii.lg}
				p={theme.spacingTokens.lg}
				gap={theme.spacingTokens.md}
			>
				<Typography variant="caption" color={theme.palette.grey[600]}>
					{intro}
				</Typography>
				<WhatToCountCategoryList categories={visibleCategories} />
			</Stack>
			<Button
				variant="textLink"
				onClick={() => setExpanded((previous) => !previous)}
				sx={{ alignSelf: "flex-start", py: theme.spacingTokens.sm }}
			>
				<ToggleIcon size={theme.iconSize.sm} />
				{expanded
					? t(Resources.Finances.WhatToCount.readLess)
					: t(Resources.Finances.WhatToCount.readMore)}
			</Button>
		</Stack>
	);
};
